const mediaItems = [
  {
    id: 1,
    title: '《星际迷途：新纪元》',
    subtitle: '科幻巨制 · 4K HDR',
    desc: '年度最受期待的科幻大片，震撼视效打造星际史诗，全程高能无尿点。',
    img: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20movie%20scene%20with%20spaceships%20in%20deep%20space%2C%20dramatic%20neon%20blue%20and%20orange%20lighting%2C%20epic%20cinematic%20composition%2C%20vibrant%20color%20grading%2C%20warm%20ambient%20glow%2C%20movie%20poster%20aesthetic%2C%20high%20contrast%2C%20film%20grain%20texture&width=800&height=500&seq=media-01-90movies&orientation=landscape',
    tag: '热门推荐',
  },
  {
    id: 2,
    title: '《长安十二时辰》续集',
    subtitle: '古装悬疑 · 全网首播',
    desc: '口碑炸裂的国产悬疑剧续作，精良制作还原大唐风华，剧情层层反转。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20at%20night%20with%20lanterns%20and%20traditional%20architecture%2C%20mysterious%20atmosphere%2C%20warm%20golden%20and%20red%20lighting%2C%20historical%20drama%20aesthetic%2C%20cinematic%20composition%2C%20misty%20ambiance%2C%20rich%20textures&width=800&height=500&seq=media-02-90movies&orientation=landscape',
    tag: '热播剧集',
  },
  {
    id: 3,
    title: '《深海奇缘》动画大电影',
    subtitle: '奇幻冒险 · 国漫之光',
    desc: '国产动画巅峰之作，瑰丽海底世界与温暖治愈故事，全年龄段必看佳作。',
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20underwater%20fantasy%20world%20with%20colorful%20coral%20reefs%20and%20schools%20of%20tropical%20fish%2C%20soft%20blue%20and%20teal%20ambient%20light%2C%20dreamy%20atmosphere%2C%20animated%20film%20aesthetic%2C%20magical%20glowing%20particles%2C%20warm%20sunlight%20streaming%20through%20water&width=800&height=500&seq=media-03-90movies&orientation=landscape',
    tag: '编辑精选',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-8 max-w-[1440px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            精彩推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[560px] mx-auto">
            每日精选高分影视内容，涵盖电影、电视剧、综艺、动漫等多个分类
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <article
              key={item.id}
              className="group relative bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium text-white bg-primary-500/90 rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-14 h-14 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                    <i className="ri-play-fill text-white text-2xl w-6 h-6 flex items-center justify-center"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-primary-500 font-medium whitespace-nowrap">
                  {item.subtitle}
                </p>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}